var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-card-wrapper",
    [
      _c("page-card", { staticClass: "sign-up-user-pass-page" }, [
        _c(
          "div",
          { staticClass: "page-card__left-half" },
          [
            _vm.model.role === "student"
              ? _c("page-title", [_vm._v("Create your student account")])
              : _vm._e(),
            _vm._v(" "),
            _vm.model.role === "teacher"
              ? _c("page-title", [_vm._v("Create your teacher account")])
              : _vm._e(),
            _vm._v(" "),
            _vm.model.role === "parent"
              ? _c("page-title", [
                  _vm._v("Create a student account for your child"),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.model.role == "parent"
              ? _c("page-subtitle", { staticClass: "subtitle" }, [
                  _vm._v(
                    "(This account will be used by your child...)\n      "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "page-card__sign-up" },
              [
                _c("google-signin-button", {
                  attrs: {
                    provider: "google",
                    role: _vm.model.role,
                    classcode: _vm.model.account.classcode,
                    refcode: _vm.model.ref,
                    action: "login",
                  },
                }),
                _vm._v(" "),
                _c("google-signin-button", {
                  attrs: {
                    provider: "microsoft",
                    role: _vm.model.role,
                    classcode: _vm.model.account.classcode,
                    refcode: _vm.model.ref,
                    action: "login",
                  },
                }),
                _vm._v(" "),
                _c("google-signin-button", {
                  attrs: {
                    provider: "clever",
                    role: _vm.model.role,
                    classcode: _vm.model.account.classcode,
                    refcode: _vm.model.ref,
                    action: "login",
                  },
                }),
                _vm._v(" "),
                _c("google-signin-button", {
                  attrs: {
                    provider: "classlink",
                    role: _vm.model.role,
                    classcode: _vm.model.account.classcode,
                    refcode: _vm.model.ref,
                    action: "login",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "page-card__sign-up__or" }, [
                  _vm._v("OR"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "page-card__sign-up__form" },
                  [
                    false
                      ? _c("rt-input", {
                          attrs: {
                            disabled: _vm.isInProgress,
                            autocomplete: "email",
                            type: "email",
                            placeholder: "Email (Optional)",
                          },
                          model: {
                            value: _vm.model.account.email,
                            callback: function ($$v) {
                              _vm.$set(_vm.model.account, "email", $$v)
                            },
                            expression: "model.account.email",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("rt-input", {
                      ref: "input_username",
                      attrs: {
                        disabled: _vm.isInProgress,
                        name: "username",
                        error: _vm.errors.username.error,
                        errorMessage: _vm.errors.username.message,
                        autocomplete: "username",
                        type: "text",
                        placeholder: "Username",
                        hint: _vm.getUsernameHint(),
                      },
                      on: {
                        enterPressed: function ($event) {
                          return _vm.handleEnterOnInput("username")
                        },
                        input: _vm.checkUsername,
                        blur: function ($event) {
                          return _vm.validate(true)
                        },
                      },
                      model: {
                        value: _vm.model.account.username,
                        callback: function ($$v) {
                          _vm.$set(_vm.model.account, "username", $$v)
                        },
                        expression: "model.account.username",
                      },
                    }),
                    _vm._v(" "),
                    _c("rt-input", {
                      ref: "input_password",
                      attrs: {
                        disabled: _vm.isInProgress,
                        name: "password",
                        error: _vm.errors.password.error,
                        errorMessage: _vm.errors.password.message,
                        type: "password",
                        autocomplete: "new-password",
                        placeholder: "Password",
                        hint: "Must be 8-16 characters and include both numbers and letters",
                      },
                      on: {
                        enterPressed: function ($event) {
                          return _vm.handleEnterOnInput("password")
                        },
                        input: function ($event) {
                          _vm.errors.password.error = false
                          _vm.checkSubmitEnabled()
                        },
                        blur: function ($event) {
                          return _vm.validate(true)
                        },
                      },
                      model: {
                        value: _vm.model.account.password,
                        callback: function ($$v) {
                          _vm.$set(_vm.model.account, "password", $$v)
                        },
                        expression: "model.account.password",
                      },
                    }),
                    _vm._v(" "),
                    _vm.model.role === "student"
                      ? _c(
                          "div",
                          { staticClass: "date-wrapper" },
                          [
                            _c("v-select", {
                              ref: "input_dob",
                              staticClass: "rt-select",
                              attrs: {
                                disabled: _vm.isInProgress,
                                label: "displayName",
                                placeholder: "Age",
                                options: _vm.ageOptions,
                              },
                              model: {
                                value: _vm.model.account.age,
                                callback: function ($$v) {
                                  _vm.$set(_vm.model.account, "age", $$v)
                                },
                                expression: "model.account.age",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.model.role === "student"
                      ? _c("rt-input", {
                          ref: "input_class_code",
                          staticStyle: { "margin-top": "7px" },
                          attrs: {
                            name: "classcode",
                            error: _vm.errors.classcode.error,
                            errorMessage: _vm.errors.classcode.message,
                            disabled:
                              _vm.isInProgress || _vm.classCodeInputDisabled,
                            type: "text",
                            placeholder: "Class Code (Optional)",
                          },
                          on: {
                            enterPressed: function ($event) {
                              return _vm.handleEnterOnInput("classcode")
                            },
                          },
                          model: {
                            value: _vm.model.account.classcode,
                            callback: function ($$v) {
                              _vm.$set(_vm.model.account, "classcode", $$v)
                            },
                            expression: "model.account.classcode",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "signup__errors" },
                      _vm._l(_vm.errors.messages, function (errorMsg, index) {
                        return _c("div", { key: index }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(errorMsg) +
                              "\n            "
                          ),
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("a", { attrs: { href: "/app/sign-up/role" } }, [
                      _vm._v("Oops, I'm not a " + _vm._s(_vm.model.role)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "terms" },
                      [
                        _c("rt-picture", {
                          staticClass: "terms__icon",
                          attrs: {
                            src: "/assets/app/signup/icon_thumbtuck.svg",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "terms__text" }, [
                          _vm._v(
                            "Creating an account means you're okay with our "
                          ),
                          _c("br"),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "https://readtheory.org/terms-and-conditions/",
                                target: "_blank",
                              },
                            },
                            [_vm._v("Terms of Use")]
                          ),
                          _vm._v(" and "),
                          _c(
                            "a",
                            {
                              attrs: {
                                target: "_blank",
                                href: "https://readtheory.org/privacy-policy/",
                              },
                            },
                            [_c("b", [_vm._v("PRIVACY POLICY")]), _vm._v(".")]
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "button-group" },
                      [
                        _c(
                          "primary-button",
                          {
                            attrs: { disabled: !_vm.isSubmitEnabled },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.submit.apply(null, arguments)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.submitBtnText))]
                        ),
                        _vm._v(" "),
                        _c(
                          "secondary-button",
                          {
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.gotoLogin.apply(null, arguments)
                              },
                            },
                          },
                          [_vm._v("Already have an account?")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "page-card__right-half" },
          [
            _c("rt-picture", {
              staticClass: "page-card__picture",
              attrs: { src: "/assets/app/signup/sign-up-pic.png" },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }